export const CASHFLOW_PERMISSIONS = {
	MANAGE_CONFIG: 'manageCashflowConfig',
	MANAGE_EXPENSE: 'manageCashflowExpense',
	SUBMIT_REPORT: 'submitCashflowReport',
	VIEW_REPORT: 'viewCashflowReport',
}

export const CASHFLOW_ROLE_DEFAULTS = {
	MANAGE_ACCOUNTS: ['admin'],
	MANAGE_CONFIG: ['admin', 'director', 'storeManager'],
	MANAGE_EXPENSE: ['admin', 'director', 'storeManager', 'cashier'],
	SUBMIT_REPORT: ['admin', 'director', 'assistant', 'cashier'],
	VIEW_REPORT: ['admin', 'director', 'storeManager', 'cashier'],
}

const hasRole = (user, roles) => roles.includes(user?.role)

const hasPermission = (user, permission) => user?.permission?.includes(permission)

const hasAnyPermission = (user, permissions) => permissions.some((permission) => hasPermission(user, permission))

export const canManageCashflowAccounts = (user) => hasRole(user, CASHFLOW_ROLE_DEFAULTS.MANAGE_ACCOUNTS)

export const canManageCashflowConfig = (user) =>
	hasRole(user, CASHFLOW_ROLE_DEFAULTS.MANAGE_CONFIG) || hasPermission(user, CASHFLOW_PERMISSIONS.MANAGE_CONFIG)

export const canManageCashflowExpense = (user) =>
	hasRole(user, CASHFLOW_ROLE_DEFAULTS.MANAGE_EXPENSE) || hasPermission(user, CASHFLOW_PERMISSIONS.MANAGE_EXPENSE)

export const canSubmitCashflowReport = (user) =>
	hasRole(user, CASHFLOW_ROLE_DEFAULTS.SUBMIT_REPORT) || hasPermission(user, CASHFLOW_PERMISSIONS.SUBMIT_REPORT)

export const canViewCashflowReport = (user) =>
	hasRole(user, CASHFLOW_ROLE_DEFAULTS.VIEW_REPORT) ||
	hasAnyPermission(user, [
		CASHFLOW_PERMISSIONS.VIEW_REPORT,
		CASHFLOW_PERMISSIONS.SUBMIT_REPORT,
		CASHFLOW_PERMISSIONS.MANAGE_EXPENSE,
		CASHFLOW_PERMISSIONS.MANAGE_CONFIG,
	])

export const canAccessCashflow = (user) => Boolean(user?.isLoggedIn && canViewCashflowReport(user))
